import React from 'react';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import ReusableLayout from '../components/ReusableLayout';


function Menu() {
  const navigate = useNavigate();

  const headerProps = {
    showBackButton: true,
    onBackClick: () => navigate(-1),
    centerContent: (
      <img
        src="/logo1.svg"
        className="w-[134px] h-auto absolute left-1/2 top-[35px] transform -translate-x-1/2 -translate-y-1/2"
        alt="Logo"
      />
    ),
    className: 'border-b border-[#233636] h-[81px] relative',
    variant: 'transparent',
  };

  return (
    <ReusableLayout
      variant="page"
      showHeader={true}
      headerProps={headerProps}
      className="min-h-[100%] text-white"
      style={{
        background: 'linear-gradient(180deg, rgb(1, 13, 13) 4%, rgb(19, 47, 50) 100%)',
      }}
    >
      <div className="flex flex-col items-center w-full px-4 py-4">
        <p className="font-raleway font-bold text-[24px] text-[#a1f69e] mb-4 text-center">О нашем приложении</p>

        <p className="text-white">
          Наше приложение помогает не просто найти пару, но и провести идеальный вечер в реальном мире.
        </p>

        <img className="w-full max-h-[262px] mb-6" src="/images/myta-idia.png" alt="myta" />
        <p className="font-bold text-lg text-white">Благодарим за выбор MYTA ❤️</p>

        <Button className="mt-[37px] mb-6" onClick={() => navigate('/calculatePage')}>
          Далее
        </Button>
      </div>
    </ReusableLayout>
  );
}

export default Menu;
